import React from 'react'
import { withPrefix } from 'gatsby'
import Logo from '../images/availability/logo.svg'
import data from '../data/footerData'

function footer () {
  return {
    navigationBackgroundColor: 'dark',
    navigationTextColor: 'white',
    disclaimerBackgroundColor: 'dark',
    disclaimerTextColor: 'white',
    logoBackgroundColor: 'dark',
    logoTextColor: 'white',
    navData: data,
    logo: <img src={Logo} alt="Logo" />,
    logoLink: withPrefix('/'),
    disclaimers: [
      {
        id: 1,
        text: 'Limited time offer, subject to change. Available only to new or returning former customers. Guarantee covers signal loss outages due to normal weather and/or technical issues. Does not cover signal loss outages due to user error. Does not cover changes in programming content. To receive outage credits, you must contact DISH customer service by phone or chat within 72 hours of the outage. Upon verifying the outage, DISH will issue bill credits in daily increments from the time of the outage until the outage is restored. Not available to DISH Outdoors customers.',
        symbol: '1',
      },
      {
        id: 2,
        text: '&copy;2024, DISH Network L.L.C. All Rights Reserved.',
      },
    ],
  }
}

export default footer
